module.exports = __webpack_public_path__ + "static/media/Pain.5fd83008.svg";